import { defineMessages } from 'react-intl-next';

export default defineMessages({
    createAction: {
        defaultMessage: 'Create "{value}"',
        description: 'Action shown to users when they have the option to create a new user',
        id: 'cv.user.picker.create.action',
    },
    addAction: {
        defaultMessage: 'Add "{value}"',
        description: 'Action shown to users when they have the option to add a existing user',
        id: 'cv.user.picker.add.action',
    },
    placeholder: {
        defaultMessage: 'Enter name or email...',
        description: 'Placeholder shown for a user to enter a name or email.',
        id: 'cv.user.picker.placeholder',
    },
    noOptionsCreatable: {
        defaultMessage: 'Enter an email to add a user',
        description:
            'Message shown to the user when no options were available and they have the option to add a new user.',
        id: 'cv.user.picker.no-options-creatable',
    },
    noOptions: {
        defaultMessage: 'No users found',
        description: 'Message shown to the user when no options were available',
        id: 'cv.user.picker.no-options',
    },
});
